/*
 * Welcome to your app's main JavaScript file!
 *
 * We recommend including the built version of this JavaScript file
 * (and its CSS file) in your base layout (base.html.twig).
 */

/* jshint esversion: 6 */
/* jshint node: true */
"use strict";

// any CSS you import will output into a single css file (app.css in this case)
import './styles/app.scss';

// start the Stimulus application
require('bootstrap');

// import $ from 'jquery';
const $ = require('jquery');
window.$ = $;

require('@symfony/ux-chartjs');
import Chart from 'chart.js/auto';


// lozad (lazy loader in pure JS)
const lozad = require('lozad');

(function() {
  let form = $("#popupLogin form").on("submit", (event) => {
    var ok = false;
    var status = -1;
    event.preventDefault();

    form.find("button[type=submit]").prop('disabled', true);

    fetch($(form).attr("action"), {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        username: $("input[name=username]").val().toLowerCase(),
        password: $("input[name=password]").val(),
        _locale: $("input[name=_locale]").val(),
        _remember_me: $("input[name=_remember_me]").is(':checked'),
      })
    })
    .then((response) => {
      ok = response.ok;
      status = response.status;
      return response.json();
    })
    .then((data) => {
      if (!ok) {
        if (status === 303) {
          postToUrl(data.redirect, {
              password: $("input[name=password]").val(),
              userId: data.userId,
            }, 'reLogin');
        } else {
          form.find('.invalid-feedback').removeClass("d-none").addClass("d-block");
          form.find(".error").addClass("d-none");
          form.find('.error.' + status).removeClass("d-none");
          form.find("button[type=submit]").prop('disabled', false);
        }
      } else {
        let callback = loginPopup.data("callback");
        loginPopup.data("callback", null);
        if (callback) {
          loginPopup.modal("hide");
          callback(true);
        } else {
          let url = loginPopup.data("return");
          if(data.redirect !== undefined) {
            url = data.redirect;
          }
          if (url) {
            window.location.href = url;
          } else {
            window.location.reload();
          }
        }
      }
    })
    .catch( () => {
      form.find('.invalid-feedback').removeClass("d-none").addClass("d-block");
      form.find("button[type=submit]").prop('disabled', false);
    });
  });

  let loginPopup = $("#popupLogin").on("show.bs.modal", () => {
    form.find('.error').addClass("d-none");
    form.find('.invalid-feedback').removeClass("d-block").addClass("d-none");
    form.find("button[type=submit]").prop('disabled', false);
  }).on('hide.bs.modal', () => {
    let callback = loginPopup.data("callback");
    loginPopup.data("callback", null);
    if (callback) callback(false);
  });

  $("#messageLogin button.submit").on("click", () => {
    let callback = loginPopup.data("callback");
    loginPopup.data("callback", null);
    if (callback) callback(true);
  });

  let messagePopup = $("#popupMessage").on('hide.bs.modal', () => {
    let callback = messagePopup.data("callback");
    messagePopup.data("callback", null);
    if (callback) callback(false);
  });

  let postToUrl = function(url, data, formId) {
    $('body').append($('<form/>')
        .attr({'action': url, 'method': 'post', 'id': 'form_' + formId})
        .append($('<input/>').attr({'type': 'hidden', 'name': 'userId', 'value': data.userId}))
        .append($('<input/>').attr({'type': 'hidden', 'name': 'password', 'value': data.password}))

    ).find('#form_' + formId).submit();
  };

  messagePopup.find(".modal-footer button.btn-primary").on("click", () => {
    let callback = messagePopup.data("callback");
    messagePopup.data("callback", null);
    if (callback) callback(true);
  });

  window.showMessagePopup = function(title, body, button) {
    let promise = new Promise((resolve, reject) => {
      messagePopup.find(".modal-title").text(title);
      let b = messagePopup.find(".modal-body");
      if (typeof body === "object") {
        b.html(body);
      } else {
        b.empty();
        body.split("\r\n").reduce((b, line) => b.append($("<div/>").text(line)), b);
      }
      messagePopup.find(".message-button").text(button || "OK");
      messagePopup.data("callback", (value) => {
        messagePopup.modal("hide");
        if (value) {
          resolve(true);
        } else {
          reject(false);
        }
      });
      messagePopup.modal("show");
    });
    return promise;
  };

  window.showLogin = function() {
    let popup = $("#popupLogin");
    return new Promise((resolve, reject) => {
      popup.data("callback", (success) => {
        if (success) {
          resolve(true);
        } else {
          reject(false);
        }
      });
      popup.modal("show");
    });
  };

/*  window.assertLogin = function(link) {
    return fetch("{{ path('api_user_ping')}}", {
      method: "POST",
      credentials: "include",
      body: "ping"
    })
    .then((response) => {
      if (response.ok) return true;
      if (response.status === 401) {
        return showLogin();
      };
      throw new Error("Błąd");
    })
  };
*/

  window.api = {};

  window.api.fetch = function(link, data, method) {
    method = method || "POST";
    return fetch(link, {
      method: method,
      credentials: "include",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    });
  };

  window.api.toggleMyList = function(link, movie_id, add) {
    return this.fetch(
      link,
      { movie_id: movie_id, my_list: add },
      "PUT"
    )
    .then((response) => {
      if (response.status === 401) {
        return showLogin().then(() => this.toggleMyList(link, movie_id, add));
      }
      if (response.ok) {
        return add;
      }
      return Promise.reject(false);
    });
  };

  window.api.activateTicket = function(link, ticket_code) {
    return this.fetch(link, { ticket_code: ticket_code })
    .then((response) => {
      if (response.status === 401) {
        return showLogin().then(() => this.activateTicket(link, ticket_code));
      }
      return response;
    });
  };

  window.api.orderTicket = function(link, movie_id, project_id, continue_url) {
    return this.fetch(
      link,
      { movie_id: movie_id, project_id: project_id, continue_url: continue_url }
    );
  };

  window.api.usePassTicket = function(link, movie_id, project_id, pass_code) {
    return this.fetch(
      link,
      { movie_id: movie_id, project_id: project_id, pass_code: pass_code }
    )
    .then((response) => {
      if (response.status === 401) {
        return showLogin().then(() => this.usePassTicket(link, movie_id, project_id, pass_code));
      }
      return response;
    });
  };

  const observer = lozad();
  observer.observe();
})();

$('.nav-item.dropdown')
  .on('mouseover', function(e) {
    e.stopPropagation();
    $('.navbar-background').css('height', $('.dropdown-menu', $(this)).outerHeight() + 'px' );
    // console.log($(this), 'mouseover');
  })
  .on('mouseout', function(e) {
    e.stopPropagation();
    $('.navbar-background').css('height', 'auto');
    // console.log($(this), 'mouseout');
  });

$('#popupLogin').find('button.close').click(function () {
  $('#popupLogin').hide();
});

$('input[type=file]').change(function() {
  $(this).parent().find("label[for='" + $(this).attr('id') + "']").text(this.value);
});

document.addEventListener("click", function(e) {
  if (e.target.classList.contains("expandable-text")) {
    e.target.classList.toggle("expanded");
  }
});
